import ProfileIndex, { ploader, paction } from './index';
//import CryptoDeposit from './Crypto';
//import Crypto from './Crypto';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

import af from './style.module.scss';

function Profile() {
  return (
    <div>
      <div className={af.body}>
        <Outlet />
      </div>
    </div>
  );
}
//    { index: true, element: <AddFundsIndex /> },

export const profileroutes = {
  path: `profile`,
  //loader: mostrloader(apiContext),
  element: <Profile />,
  children: [
    { index: true, element: <ProfileIndex />, loader: ploader, action: paction },
    /*{
      path: 'crypto',
      element: <CryptoDeposit />,
      //loader: contactLoader,
    },*/
  ],
};
